import { type CSSProperties, type ReactNode } from 'react';
import styles from './Card.module.css';

interface CardProps {
  children: ReactNode;
  className?: string;
  variant?: 'light' | 'dark' | 'soft';
  padding?: 'none' | 'sm' | 'md' | 'lg';
  style?: CSSProperties;
}

export function Card({
  children,
  className = '',
  variant = 'light',
  padding = 'md',
  style,
}: CardProps): JSX.Element {
  return (
    <div
      className={`${styles.card} ${styles[`v_${variant}`]} ${styles[`p_${padding}`]} ${className}`}
      style={style}
    >
      {children}
    </div>
  );
}
